import styled from 'styled-components';
import { DFV_BG_COLOR } from '../DynamicFieldView/DynamicFieldView.style';
import { motion } from 'framer-motion';
import GDBREAKPOINTS from '../themes/breakpoints';

const DfvChipFeedWrapper = styled.div`
    height: 100%;
    width: 100%;
    display: grid;
  	grid-template-rows: 1fr auto;
    position: absolute;
    top:0;
    background-color: ${DFV_BG_COLOR};
    opacity: 0;
    z-index: -1;
    aspect-ratio: 20 / 17;
    @media (min-width: ${GDBREAKPOINTS.SM_MIN}) {
        aspect-ratio: 25 / 16;
    }
`;

export const MotionDfvChipFeedWrapper = motion(DfvChipFeedWrapper);
